import { useCallback } from 'react';
import { api } from '../utils/apiHandler';
import type { AxiosResponse } from 'axios';
import type { MatchResponse } from './types/matchTypes';

const USERS_PATH = '/users';

const useMatchResource = () => {
  // Get match info
  const getMatch = useCallback(async (user_id: string, match_handle: string): Promise<MatchResponse> => {
    const response: AxiosResponse<MatchResponse> = await api.request<undefined, AxiosResponse<MatchResponse>>({
      method: 'GET',
      url: `${USERS_PATH}/${user_id}/match/${match_handle}`
    });
    return response.data;
  }, []);

  // Post match
  const createMatch = useCallback(async (user_id: string, match_handle: string): Promise<MatchResponse> => {
    const response: AxiosResponse<MatchResponse> = await api.request<undefined, AxiosResponse<MatchResponse>>({
      method: 'POST',
      url: `${USERS_PATH}/${user_id}/match/${match_handle}`
    });
    return response.data;
  }, []);

  return { getMatch, createMatch };
};

export default useMatchResource;
